<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row">
      <div class="col-4">
        <app-input
          label="Nome"
          v-model="apiUser.user.name"
          :errors="errors['user.name']"
          v-app-regex-filter="/\d/g"
        ></app-input>
      </div>
      <div class="col-4">
        <app-input
          label="E-mail"
          v-model="apiUser.user.email"
          :errors="errors['user.email']"
        ></app-input>
      </div>
      <div class="col-4">
        <app-input
          label="Telefone"
          v-model="apiUser.phone"
          :errors="errors.phone"
          v-mask="'(##) ####-####'"
        ></app-input>
      </div>
      <div class="col-4">
        <app-autocomplete
          label="Rede"
          field="name"
          :searchFunction="searchNetworkFn"
          :resourceIdFunction="resourceNetworkFn"
          v-model="apiUser.network_id"
          :errors="errors.network_id"
          required
        ></app-autocomplete>
      </div>
      <div class="col-4">
        <b-field label="Senha" :required="!id">
          <b-input
            v-model="apiUser.user.password"
            placeholder="Senha"
            type="password"
            password-reveal
          ></b-input>
        </b-field>
      </div>
      <div class="col-4">
        <b-field
          label="Confirmar Senha"
          :required="!id || apiUser.user.password != ''"
        >
          <b-input
            v-model="apiUser.user.password_confirmation"
            placeholder="Confirmar Senha"
            type="password"
            password-reveal
          ></b-input>
        </b-field>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import ApiUserService from '@/services/api-user.service';
import NetworkService from '@/services/network.service';
import ToastMixin from '@/mixins/ToastifyMixin';

import { required, email, minLength, sameAs } from 'vuelidate/src/validators';

export default {
  name: 'api-user-form',
  props: ['id', 'errors', 'saving'],
  mixins: [ToastMixin],
  data: () => {
    return {
      loading: true,
      apiUser: {
        phone: null,
        network: null,
        user: {
          name: null,
          email: null,
          password: null,
          password_confirmation: null,
        },
      },
    };
  },
  validations() {
    return {
      apiUser: {
        network_id: { required },
        user: {
          name: { required },
          email: { required, email },
          password: !this.id
            ? { required, minLength: minLength(6) }
            : {
                minLength: minLength(this.apiUser.user.password === '' ? 0 : 6),
              },
          password_confirmation: !this.id
            ? { required, sameAsPassword: sameAs('password') }
            : this.apiUser.user.password === ''
            ? {}
            : { sameAsPassword: sameAs('password') },
        },
      },
    };
  },
  methods: {
    loadApiUser(id) {
      ApiUserService.getId(id)
        .then(({ data }) => {
          this.apiUser = data;
        })
        .catch(() => this.toastify('Erro ao carregar Usuário.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', this.apiUser);
    },
    searchNetworkFn: NetworkService.search,
    resourceNetworkFn: NetworkService.getId,
  },
  beforeMount() {
    if (this.id) this.loadApiUser(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped></style>
